import * as proto from "./proto";

export const block_oneof = {
    "generator_static": proto.generator.static_color,
    "output_addressable": proto.output.addressable,
    "processing_repeater": proto.processing.repeater,
};
